// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1yMgU","info":"PatientInfo_info__2fka9"};